/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type VelocityReportEntrypointComponent = EntryPointComponent<{}, {}, {}, {}>;

export const velocityReportEntrypoint: EntryPoint<VelocityReportEntrypointComponent, {}> =
	createEntryPoint({
		root: JSResourceForUserVisible<VelocityReportEntrypointComponent>(
			/* webpackChunkName: "async-next-gen-reports-velocity-entrypoint" */ './index.tsx',
			{
				entryFsSsrLiftImportToModule: true,
			},
		),
		getPreloadProps: () => ({}),
	});
